<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      persistent
      :width="width"
    >
      <v-card>
        <v-toolbar v-if="titulo && tituloEnToolbar" flat height="40px" color="rgb(18, 77, 145)" style="color: white" class="text-body-1">
          {{titulo}}
        </v-toolbar>

        <v-card-title v-else-if="titulo" class="text-body-1">
          {{titulo}}
        </v-card-title>

        <v-card-text v-if="texto">
          <div class="mt-3 text-body-2 font-weight-bold" v-html="texto">
            {{texto}}
          </div>
        </v-card-text>

        <!-- Slot custom <v-card-text></v-card-text> -->
        <slot name="texto">
        </slot>
        <v-card-actions class="gap-3">
          <v-spacer></v-spacer>
          <v-btn
            color="rgb(18, 77, 145)"
            text
            class="text-decoration-underline"
            @click.stop="dialog = false"
          >
            Cerrar
          </v-btn>  

          <slot name="botonPrincipal">
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "ModalGenericoAccion",
  props: {
    titulo: { type: String, default: "", required: false},
    tituloEnToolbar: { type: Boolean, default: false, required: false},
    texto: { type: String, default: "", required: false},
    width: { type: String, default: "50%", required: false},
    value: { type: Boolean, default: false, required: false},
  },
  data: () => ({}),

  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

  methods: {},

  watch: {},
};
</script>

<style scoped>
</style>